<div class="modal-overlay">
  <div class="admin-modal" style="width: 900px;" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">Reorder Tasks / Reshuffle Sub Tasks</h3>
      <div class="header-actions">
        <i class="fa fa-minus-square-o" style="margin-right: 10px; cursor: pointer;" title="Minimize" (click)="close()"></i>
        <i class="fa fa-times" style="cursor: pointer;" title="Close" (click)="close()"></i>
      </div>
    </div>
    <div class="modal-body">
      <div class="row" style="margin-bottom: 10px;">
        <div class="col-md-12 text-center">
          <label style="margin-right: 10px;"><input type="radio" name="reorderMode" [checked]="reorderMode" (change)="setReorderMode(true)"> Reorder Tasks</label>
          <label><input type="radio" name="reorderMode" [checked]="!reorderMode" (change)="setReorderMode(false)"> Reorder Sub Tasks</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="panel panel-default">
            <div class="panel-heading"><b>Tasks</b></div>
            <ul class="list-group" style="max-height: 360px; overflow: auto;"
              cdkDropList [cdkDropListData]="reorderTasksList" [cdkDropListDisabled]="!reorderMode" (cdkDropListDropped)="dropReorderTasks($event)">
              @for (task of reorderTasksList; track $index) {
<li class="list-group-item"
                [class.active]="reorderTaskModel?.task_key === task?.task_key"
                (click)="reorderSelectTask(task)" [style.cursor]="reorderMode ? 'move' : 'pointer'"
                cdkDrag [cdkDragDisabled]="!reorderMode">
                <span>{{task.task_name}}</span>
                @if (reorderMode) {
<span class="pull-right"><i class="fa fa-ellipsis-v"></i><i class="fa fa-ellipsis-v"></i></span>
}
              </li>
}
            </ul>
          </div>
        </div>
        <div class="col-md-6">
          <div class="panel panel-default">
            <div class="panel-heading"><b>Sub Tasks</b></div>
            <ul class="list-group" style="max-height: 360px; overflow: auto;"
              cdkDropList [cdkDropListData]="reorderSubTasksList" [cdkDropListDisabled]="reorderMode" (cdkDropListDropped)="dropReorderSubTasks($event)">
              @for (task of reorderSubTasksList; track $index) {
<li class="list-group-item"
                cdkDrag [cdkDragDisabled]="reorderMode" [style.cursor]="reorderMode ? 'default' : 'move'">
                <span>{{task.task_name}}</span>
                @if (!reorderMode) {
<span class="pull-right"><i class="fa fa-ellipsis-v"></i><i class="fa fa-ellipsis-v"></i></span>
}
              </li>
}
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-success btn-sm" type="button" (click)="applyReorder()">Apply @if (reorderTaskLoader) {
<i class="fa fa-spinner fa-spin"></i>
}</button>
      <button class="btn btn-danger btn-sm" type="button" (click)="clearReorder()">Clear</button>
      <button class="btn btn-info btn-sm" type="button" (click)="close()">Cancel</button>
    </div>
  </div>
</div>
